import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

interface ErrorBoundaryProps {
  children?: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    hasError: false,
    error: null
  };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{padding: '40px', color: '#0F172A', fontFamily: 'system-ui, sans-serif', maxWidth: '600px', margin: '0 auto', textAlign: 'center'}}>
          <h1 style={{fontSize: '24px', fontWeight: 'bold', marginBottom: '16px'}}>Something went wrong.</h1>
          <p style={{color: '#64748B', marginBottom: '24px'}}>The application encountered an unexpected error.</p>
          <button 
            onClick={() => window.location.reload()} 
            style={{padding: '10px 20px', backgroundColor: '#0F172A', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer'}}
          >
            Reload Page
          </button>
          <details style={{marginTop: '40px', padding: '20px', background: '#F1F5F9', borderRadius: '12px', textAlign: 'left', fontSize: '12px', overflow: 'auto'}}>
            <summary style={{cursor: 'pointer', fontWeight: 'bold', color: '#475569'}}>Error Details (for developers)</summary>
            <pre style={{marginTop: '10px', whiteSpace: 'pre-wrap', color: '#DC2626'}}>{this.state.error?.toString()}</pre>
          </details>
        </div>
      );
    }

    return (this as any).props.children;
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);